import type { NextPage, GetStaticProps } from "next";
import { MainPage } from "@/components/pages";
import useFixedAuth from "@/libs/useFixedAuth";
import useCheckAuth from "@/libs/useCheckAuth";
import { useRollbarContext } from "@rollbar/react";
import { useRouter } from "next/router";

const Home: NextPage = () => {
  useRollbarContext("home");

  const router = useRouter();

  const { authStatus } = useFixedAuth();
  useCheckAuth({
    authStatus,
    redirectToIfSignedOut: "/sign-in",
    redirectToIfSignedInParams: router.query,
    redirectToIfSignedIn: "/select-service",
    redirectToIfSignedOutParams: router.query,
  });

  return <MainPage />;
};

export default Home;

export const getStaticProps: GetStaticProps = async () => {
  const posts = {};
  return {
    props: { posts },
  };
};
